import styled from "styled-components";
import { Link } from "react-router-dom";
import { COR_GRADE, COR_SUPERFICIE, COR_TEXTO } from "../../Relatorios/painel";

// Pedidos aguardando: é o que exige AÇÃO do administrador, então vem primeiro e
// com cor de atenção (mesmos tons do KPI de pendência). Sem pendência, vira uma
// linha discreta: a ausência de trabalho não deve disputar atenção.
export const Destaque = styled.section`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px 24px;
  width: 100%;
  padding: 16px 20px;
  border-radius: 8px;
  border: 1.5px solid ${(p) => (p.$atencao ? "#F0DBA8" : COR_GRADE)};
  background: ${(p) => (p.$atencao ? "#FFFBF1" : COR_SUPERFICIE)};

  .texto{ display: flex; flex-direction: column; gap: 2px; }
  .botoes{ display: flex; flex-wrap: wrap; gap: 8px; }
  .titulo{ font-size: ${(p) => (p.$atencao ? "18px" : "14px")}; font-weight: 700; }
  .detalhe{ font-size: 13px; color: ${COR_TEXTO}; }
  .erro{ font-size: 13px; color: #C43333; }
  a{ font-size: 13px; font-weight: 600; color: var(--primary-color); }
  a:focus-visible{ outline: 2px solid var(--primary-color); outline-offset: 2px; }
`;

export const BotaoLink = styled(Link)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 36px;
  padding: 0 18px;
  border-radius: 8px;
  background: var(--primary-color);
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  text-decoration: none;
  white-space: nowrap;

  /* O duplo & sobe a especificidade: o Destaque pinta seus links de verde (a{...}) e
     isso deixava o texto do botão verde sobre verde, ilegível. */
  && { color: #fff; }
  &:focus-visible{ outline: 2px solid #111; outline-offset: 2px; }
`;

export const Atalhos = styled.nav`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(190px, 1fr));
  gap: 12px;
  width: 100%;

  a{
    display: flex;
    flex-direction: column;
    gap: 2px;
    padding: 12px 16px;
    border-radius: 8px;
    border: 1.5px solid ${COR_GRADE};
    background: ${COR_SUPERFICIE};
    color: inherit;
    text-decoration: none;

    strong{ font-size: 14px; }
    span{ font-size: 12px; color: ${COR_TEXTO}; }

    &:hover{ border-color: var(--primary-color); }
    &:focus-visible{ outline: 2px solid var(--primary-color); outline-offset: 2px; }
  }
`;

// Duas colunas fixas. Com `auto-fit`, o <details> da tabela (que ocupa todas as
// colunas) mantinha uma terceira coluna vazia e cada gráfico ficava com 1/3 da
// largura, sobrando espaço em branco à direita.
export const Graficos = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px 24px;

  @media screen and (max-width: 900px){
    grid-template-columns: minmax(0, 1fr);
  }

  .grafico{ min-width: 0; }
  .grafico h4{ margin: 0 0 4px; font-size: 13px; font-weight: 700; color: ${COR_TEXTO}; }

  details{ margin-top: 4px; font-size: 12px; color: ${COR_TEXTO}; }
  summary{ cursor: pointer; width: fit-content; }
  summary:focus-visible{ outline: 2px solid var(--primary-color); outline-offset: 2px; }
  table{ margin-top: 8px; width: 100%; border-collapse: collapse; font-size: 12px; }
  th, td{ padding: 4px 8px; border-top: 1px solid ${COR_GRADE}; text-align: right; font-variant-numeric: tabular-nums; }
  th:first-child, td:first-child{ text-align: left; }
`;

export const Recentes = styled.div`
  width: 100%;
  min-width: 0;

  .principal{ font-weight: 600; overflow-wrap: anywhere; }
  .meta{ font-size: 12px; color: ${COR_TEXTO}; overflow-wrap: anywhere; }
  .data{ font-size: 12px; color: ${COR_TEXTO}; white-space: nowrap; }

  .selo{
    display: inline-block;
    padding: 2px 8px;
    border-radius: 10px;
    font-size: 11px;
    font-weight: 600;
    border: 1px solid transparent;
    background: #EFF0F2;
    color: ${COR_TEXTO};

    &.tipo-Administrador{ background: #E8EEF5; color: #26466D; border-color: #C6D3E3; }
    &.tipo-Profissional{ background: #E4F4E7; color: #1f7a33; border-color: #BFE0C5; }
    &.tipo-Comum{ background: #F1F2F4; color: #4D4F50; border-color: #DDDFE3; }
    &.status-Ativo{ background: #fff; color: #1f7a33; border-color: #BFE0C5; }
    &.status-Inativo{ background: #FDF3F3; color: #A12A2A; border-color: #F0CACA; }
    &.status-Aguardando{ background: #FFF7E5; color: #8A5A00; border-color: #F0DBA8; }
    &.Pendente{ background: #FFF7E5; color: #8A5A00; border-color: #F0DBA8; }
    &.Aprovada{ background: #E4F4E7; color: #1f7a33; border-color: #BFE0C5; }
    &.Recusada{ background: #FDF3F3; color: #A12A2A; border-color: #F0CACA; }
  }
`;
